import { render, staticRenderFns } from "./ContactosPersona2.vue?vue&type=template&id=0960680d"
import script from "./ContactosPersona2.vue?vue&type=script&lang=js"
export * from "./ContactosPersona2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports